import { render, staticRenderFns } from "./BaseMultipleSelect.vue?vue&type=template&id=231234f9&"
import script from "./BaseMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleSelect.vue?vue&type=style&index=0&id=231234f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports